import { render, staticRenderFns } from "./BreakdayPicker.vue?vue&type=template&id=588d8a22&"
import script from "./BreakdayPicker.vue?vue&type=script&lang=js&"
export * from "./BreakdayPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports